const INPUT_SELECTOR = 'select:not([multiple]).select2-fw';

const OPTION_DEFAULTS = {
    closeOnSelect: true,
    minimumResultsForSearch: 7,
    width: '100%',
};

const SelectInput = {
    init: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        const $inputs = $scope.find(INPUT_SELECTOR);

        $inputs.each(function() {
            const $input = $(this);
            const options = Object.assign({}, OPTION_DEFAULTS);

            if ($input.data('placeholder')) {
                options.placeholder = $input.data('placeholder');
            }

            if ($input.data('search') === false) {
                options.minimumResultsForSearch = -1;
            }

            if ($input.data('tags') === true) {
                options.tags = true;
                options.minimumResultsForSearch = 0;
            }

            if ($input.hasClass('form-control-dark')) {
                options.theme = 'dark';
            }

            // https://select2.org/troubleshooting/common-problems#select2-does-not-function-properly-when-i-use-it-inside-a-bootst
            const $modal = $input.closest('.modal');

            if ($modal.length) {
                options.dropdownParent = $modal.find('.modal-body')
                    || $modal.find('.modal-content')
                    || $modal;
            }

            $input.select2(options);
        });
    },
    destroy: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        const $inputs = $scope.find(INPUT_SELECTOR);

        $inputs.each(function() {
            $(this).select2('destroy');
        });
    },
};

export default SelectInput;
